<template>
  <header class="root-container" :style="hackZindexStyle">
    <img class="cover" :src="getCoverImg" />
    <section class="container">
      <img class="icon" :src="gameIconPic" alt="icon" />
      <div class="title-container">
        <div class="title" v-if="!(gameName === 'freefire' && region === 'in')">
          {{ $t('common.mifansText') }}
        </div>
        <div class="title" v-else>{{ $t('freefire.game_desc') }}</div>
      </div>
      <region-lang-popup v-show="false" :page="this.gameName" />
      <span class="login-btn">
        <UserCenter
          :page="gameName"
          ref="loginComp"
          @login="getLoginResult"
          type="gameTurbo"
          v-show="!isGenshinEn"
        />
      </span>
    </section>
  </header>
</template>

<script>
  import UserCenter from '@/components/UserCenter'
  import RegionLangPopup from '@/components/RegionLangPopup'
  import styleConfiguration from '@/mixins/detail/styleConfiguration'
  import { mapState, mapGetters } from 'vuex'
  export default {
    mixins: [styleConfiguration],
    components: {
      UserCenter,
      RegionLangPopup,
    },
    computed: {
      ...mapState(['gameName', 'region', 'watchCouponState']),
      ...mapGetters(['isGenshinEn']),
      // hack 解决层级的问题
      // popup vant版本较低【下次优化】
      hackZindexStyle() {
        return {
          zIndex: this.watchCouponState ? 1 : 12,
        }
      },
      gameIconPic() {
        return this.gameIcon || ''
      },
    },
    methods: {
      login(type) {
        this.$refs.loginComp && this.$refs.loginComp.loginBtn(type)
      },
      getLoginResult(res) {
        this.$emit('login', res)
      },
    },
  }
</script>

<style scoped lang="scss" src="./game_turbo.scss"></style>
<style scoped lang="scss">
  @media screen and (min-device-width: 1080px) {
    @import './game_turbo.scss';
  }
</style>
